const PaymentMgmtList = resolve => require(['@/views/PaymentMgmt/List'], resolve)
const PaymentMgmtDetail = resolve => require(['@/views/PaymentMgmt/Detail'], resolve)
export default [{
  name: 'PaymentMgmt_list',
  path: '/paymentMgmt/list',
  component: PaymentMgmtList,
  meta: {
    keepAlive: false,
    title: '收款管理列表',
  },
}, {
  name: 'PaymentMgmt_detail',
  path: '/paymentMgmt/list/detail',
  component: PaymentMgmtDetail,
  meta: {
    keepAlive: false,
    title: '收款管理详情',
  },
}]



// WEBPACK FOOTER //
// ./src/router/paymentMgmt.js